module.exports = __webpack_public_path__ + "img/cash_in.1d66a317.png";